import React, { useState, useEffect, useRef, useReducer } from 'react'
import styled, { css } from 'styled-components'
import { Swiper } from 'antd-mobile'
import IosSpinner from '../../Chats/IosSpinner'
import { useSearchParams } from 'react-router-dom'
import { useParams } from 'react-router-dom' //Outlet, useNavigate, useLocation
import _ from 'lodash'
import moment from 'moment'
import NativeItem from './components/nativeItem'
import Indicator from './components/indicator'
import {
  getHealthySignals,
  getHealthySignalsSettings,
  getMeByHash,
  getHealthySignalsPercentageTarget
} from '../../../api'
import { getHealthySignalsHSD, getHealthySignalsWeeklyData } from '../../../api/healthySignals'
import { getToken, setTokenItem, saveUser } from '../../../utils/storage'
import {
  prevWeekDate,
  nextWeekDate,
  getThisWeekRange
} from '../../../utils/dateHandles'

const Container = styled.div`
  header {
    background: #ffffff;
    height: 6.5rem;
    position: relative;
    .type-switch {
      position: absolute;
      background: #edf0ff;
      color: #0a2845;
      display: flex;
      top: 1rem;
      left: 50%;
      transform: translateX(-50%);
      border-radius: 1.5rem;
      padding: 2px;
      & > div {
        width: 7.5rem;
        height: 2.5rem;
        line-height: 2.5rem;
        font-family: Inter, Gilroy;
        font-size: 0.875rem;
        font-weight: 600;
        letter-spacing: 0px;
        text-align: center;
        border-radius: 100%;
        &.active {
          background: #0077e4;
          border-radius: 1.5rem;
          color: #ffffff;
        }
      }
    }
    .indicators {
      transform: rotatey(180deg);
      position: absolute;
      bottom: 0;
      width: 100vw;
      overflow: hidden;
      .adm-swiper-track-inner {
        ${(props) =>
          css`
            .adm-swiper-slide:nth-child(${props.activeIndex + 2 - 1})
              .adm-swiper-item
              > div {
              background: -webkit-linear-gradient(right, #ffffff, #383e48);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
            .adm-swiper-slide:nth-child(${props.activeIndex + 2 + 1})
              .adm-swiper-item
              > div {
              background: -webkit-linear-gradient(left, #ffffff, #383e48);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
          `}
      }
    }
    .adm-swiper-indicator {
      bottom: 0;
      .adm-page-indicator-dot {
        background: transparent;
        display: none;
      }
      .adm-page-indicator-dot-active {
        width: 33vw;
        display: block;
        background: linear-gradient(221deg, #0077e4 0.45%, #0c4bc1 77.66%);
      }
    }
  }
  .page-indicators {
    display: flex;
    .active {
      color: blue;
    }
    & > div {
      width: 33vw;
      text-align: center;
    }
  }
  .container {
    height: calc(100vh - 6.5rem);
    transform: rotatey(180deg);
    .adm-swiper-indicator {
      display: none;
    }
  }
  .swiper-content {
    height: 100%;
  }
`

const initialState = {
  dataList: [{ isLoading: true }, { isLoading: true }],
  targets: {},
  settings: [],
  personId: null
}

export default function NativeHSD(props) {
  const { hash } = useParams()
  const [searchParams] = useSearchParams()
  const ref = useRef(null)
  const indicatorsRef = useRef(null)
  const [pageLoading, setPageLoading] = useState(true)
  const [rangeType, setRangeType] = useState('week')
  const [activeIndex, setActiveIndex] = useState(getDefaultActive())
  const [showWorkoutPopup, setShowWorkoutPopup] = useState(false)
  const [activeGroups, setActiveGroups] = useState(
    activeIndex === 0
      ? [activeIndex, activeIndex + 1, activeIndex + 2]
      : [activeIndex - 1, activeIndex, activeIndex + 1]
  )
  const [state, dispatch] = useReducer(reducer, initialState)

  const ensureToken = () => {
    if (navigator.userAgent.includes('life.apeiron.ios') && !getToken()) {
      try {
        if (window.webkit?.messageHandlers?.loadUser) {
          window.webkit.messageHandlers.loadUser.postMessage({})
          return new Promise(resolve => setTimeout(resolve, 1000))
        }
      } catch (err) {
        console.error('🚨 Failed to request token from native app:', err)
      }
    }
    return Promise.resolve()
  }

  const refreshPerson = async (token) => {
    setTokenItem(token)
    const { person } = await getMeByHash(hash)
    saveUser(person)
  }

  useEffect(() => {
    window.handleMessageFromNative = refreshPerson

    let from, to

    if (searchParams.has('from') && searchParams.has('to')) {
      from = searchParams.get('from')
      to = searchParams.get('to')
    }
    dispatch({
      type: 'initial',
      payload: { from: from && moment(from), to: to && moment(to) }
    })
  }, [searchParams])

  const { dataList, targets, settings, personId } = state

  return (
    <Container activeIndex={activeIndex}>
      {pageLoading && <IosSpinner />}
      <header>
        <div className="type-switch">
          <div
            className={rangeType === 'week' ? 'active' : ''}
            onClick={() => setRangeType('week')}
          >
            Week
          </div>
          <div
            className={rangeType !== 'week' ? 'active' : ''}
            onClick={() => setRangeType('avg')}
          >
            3-week AVG
          </div>
        </div>
        {!pageLoading && (
          <div className="indicators">
            <Swiper
              style={{ '--height': 100 }}
              defaultIndex={activeIndex}
              ref={indicatorsRef}
              allowTouchMove={false}
              slideSize={33.3}
            >
              <Swiper.Item>
                <div />
              </Swiper.Item>

              {dataList.map((item, index) => {
                return (
                  <Swiper.Item key={index}>
                    <Indicator
                      isActive={
                        dataList[activeIndex] &&
                        item.weekNth === dataList[activeIndex].weekNth
                      }
                      gesture={(clientX) => {
                        handleGesture(clientX, index)
                      }}
                      onClick={() => swiperTo(index)}
                      item={item}
                    />
                  </Swiper.Item>
                )
              })}
              <Swiper.Item>
                <div />
              </Swiper.Item>
            </Swiper>
          </div>
        )}
      </header>
      <div className="container">
        <Swiper
          style={{ '--height': '100%' }}
          defaultIndex={activeGroups.findIndex(
            (index) => index === activeIndex
          )}
          ref={ref}
          allowTouchMove={false}
          onIndexChange={onIndexChange}
          loop={true}
        >
          <Swiper.Item>
            {dataList[activeGroups[0]] ? (
              <NativeItem
                gesture={(clientX) => handleGesture(clientX, activeGroups[0])}
                {...{
                  settings,
                  targets,
                  item: dataList[activeGroups[0]]
                }}
                rangeType={rangeType}
                showWorkoutPopup={
                  showWorkoutPopup && activeGroups[0] === activeIndex
                }
                setShowWorkoutPopup={setShowWorkoutPopup}
                sleepData={dataList[activeGroups[0]].sleepData}
                overviewSummary={dataList[activeGroups[0]].overviewSummary}
                sleepPercentage={dataList[activeGroups[0]].sleepPercentage}
                sleep3WeekPercentage={dataList[activeGroups[0]].sleep3WeekPercentage}
                sleep3WeekAverage={dataList[activeGroups[0]].sleep3WeekAverage}
              />
            ) : (
              <div />
            )}
          </Swiper.Item>
          <Swiper.Item>
            {dataList[activeGroups[1]] ? (
              <NativeItem
                gesture={(clientX) => handleGesture(clientX, activeGroups[1])}
                {...{
                  settings,
                  targets,
                  item: dataList[activeGroups[1]]
                }}
                rangeType={rangeType}
                showWorkoutPopup={
                  showWorkoutPopup && activeGroups[1] === activeIndex
                }
                setShowWorkoutPopup={setShowWorkoutPopup}
                sleepData={dataList[activeGroups[1]].sleepData}
                overviewSummary={dataList[activeGroups[1]].overviewSummary}
                sleepPercentage={dataList[activeGroups[1]].sleepPercentage}
                sleep3WeekPercentage={dataList[activeGroups[1]].sleep3WeekPercentage}
                sleep3WeekAverage={dataList[activeGroups[1]].sleep3WeekAverage}
              />
            ) : (
              <div />
            )}
          </Swiper.Item>
          <Swiper.Item>
            {dataList[activeGroups[2]] ? (
              <NativeItem
                gesture={(clientX) => handleGesture(clientX, activeGroups[2])}
                {...{
                  settings,
                  targets,
                  item: dataList[activeGroups[2]]
                }}
                rangeType={rangeType}
                showWorkoutPopup={
                  showWorkoutPopup && activeGroups[2] === activeIndex
                }
                setShowWorkoutPopup={setShowWorkoutPopup}
                sleepData={dataList[activeGroups[2]].sleepData}
                overviewSummary={dataList[activeGroups[2]].overviewSummary}
                sleepPercentage={dataList[activeGroups[2]].sleepPercentage}
                sleep3WeekPercentage={dataList[activeGroups[2]].sleep3WeekPercentage}
                sleep3WeekAverage={dataList[activeGroups[2]].sleep3WeekAverage}
              />
            ) : (
              <div />
            )}
          </Swiper.Item>
        </Swiper>
      </div>
    </Container>
  )

  function reducer(state, action) {
    if (action.type === 'initial') {
      const { from, to } = action.payload
      initial(from, to)
      return state // _.assign({}, state, action.payload)
    }

    return _.assign({}, state, action.payload || {})
  }

  async function initial(from, to) {
    if (!(from && to)) {
      const { startDate, endDate } = getThisWeekRange()
      from = startDate
      to = endDate
    }

    const { settings } = await getHealthySignalsSettings(hash)
    const { person } = await getMeByHash(hash)

    await ensureToken()

    let healthySignals = []
    const hasToken = !!getToken()
    if (hasToken) {
      try {
        const prevWeekStartDate = moment(from)
          .subtract(6, 'days')
          .format('YYYY-MM-DD')
        const hsdResponse = await getHealthySignalsHSD(
          person.id,
          prevWeekStartDate,
          moment(to).format('YYYY-MM-DD'),
          'json',
          'ouraring'
        )
        
        healthySignals = hsdResponse || []
      } catch (e) {
        console.log('==========> HSD service error', e)
        healthySignals = []
      }
    } else {
      console.log('==========> Skipping HSD API - no authentication token available')
      healthySignals = []
    }
    const result = await getHealthySignalsPercentageTarget(
      person.id,
      moment(from).format('YYYY-MM-DD'),
      hash
    )
    const targets = {}
    _(result).forEach((item) => {
      targets[item.domain] = item.target
    })

    const activeIndex = getDefaultActive()
    const dataList = new Array(activeIndex + 3).fill({
      isLoading: true
    })

    let _payload = await fetchData(person.id, from, to, true)
    dataList[activeIndex] = _payload
    // const dataList = [_payload]
    dispatch({ type: 'update', payload: { dataList, targets, settings, personId: person.id } })
    const { startDate: _from, endDate: _to } = prevWeekDate(
      from.clone(),
      to.clone()
    )
    _payload = await fetchData(person.id, _from, _to)
    dataList[activeIndex + 1] = _payload
    if (activeIndex) {
      const { startDate: __from, endDate: __to } = nextWeekDate(
        from.clone(),
        to.clone()
      )
      _payload = await fetchData(person.id, __from, __to)
      dataList[activeIndex - 1] = _payload
    } else {
      const { startDate: __from, endDate: __to } = prevWeekDate(
        _from.clone(),
        _to.clone()
      )
      _payload = await fetchData(person.id, __from, __to)
      dataList[activeIndex + 2] = _payload
    }

    dispatch({ type: 'update', payload: { dataList } })
    setPageLoading(false)
    setShowWorkoutPopup(true)
  }

  async function fetchData(personId, from, to, isInitial) {
    const requestType = 'week'
    const result = await getHealthySignals({
      rangeType: requestType,
      from: moment(from).format('YYYY-MM-DD'),
      to: moment(to).format('YYYY-MM-DD'),
      hash: hash
    })
    let healthySignals = []
    let weeklyHealthySignalsData = []
    const hasToken = !!getToken()
    if (hasToken) {
      try {
        healthySignals = await getHealthySignalsHSD(
          personId,
          moment(from).subtract(6, 'days').format('YYYY-MM-DD'),
          moment(to).format('YYYY-MM-DD'),
          'json',
          'ouraring'
        ) || []
        
        weeklyHealthySignalsData = await getHealthySignalsWeeklyData(
          personId,
          moment(to).format('YYYY-MM-DD'),
          'json',
          'ouraring'
        )
      } catch (e) {
        console.log('==========> HSD service error in fetchData', e)
        healthySignals = []
        weeklyHealthySignalsData = []
      }
    } else {
      console.log('==========> Skipping HSD API in fetchData - no authentication token available')
      healthySignals = []
      weeklyHealthySignalsData = []
    }
    
    let sleepPercentage = 0
    let sleep3WeekPercentage = 0
    let sleep3WeekAverage = null
    
    if (weeklyHealthySignalsData && weeklyHealthySignalsData.week_total) {
      let total = 0
      Object.entries(weeklyHealthySignalsData.week_total).forEach(([key, value]) => {
        if (key.includes('modified')) {
          total += Math.round(value || 0)
        }
      })
      sleepPercentage = total / 7
      
      if (weeklyHealthySignalsData.three_week_avg) {
        let total_3week = 0
        Object.entries(weeklyHealthySignalsData.three_week_avg).forEach(([key, value]) => {
          if (key.includes('modified')) {
            total_3week += Math.round(value || 0)
          }
        })
        sleep3WeekPercentage = total_3week / 7
        sleep3WeekAverage = weeklyHealthySignalsData.three_week_avg
      }
    }
    
    const hsdData = healthySignals.healthy_signals_data || healthySignals
    const prevWeekStartDate = moment(from).subtract(6, 'days')
    const weekData = Array.isArray(hsdData) ? hsdData.filter(d => moment(d.record_date).isBetween(prevWeekStartDate, to, null, '[]')) : []

    if (result.week_data && Array.isArray(hsdData)) {
      Object.keys(result.week_data).forEach(domain => {
        const domainData = result.week_data[domain]
        if (domainData && Array.isArray(domainData.seg_workouts)) {
          const workoutsByDate = {}
          domainData.seg_workouts.forEach(workout => {
            if (workout && workout.record_date) {
              if (!workoutsByDate[workout.record_date]) {
                workoutsByDate[workout.record_date] = []
              }
              workoutsByDate[workout.record_date].push(workout)
            }
          })

          Object.keys(workoutsByDate).forEach(date => {
            const dateWorkouts = workoutsByDate[date]
            const hsdItem = hsdData.find(item => item && item.record_date === date)

            if (hsdItem && typeof hsdItem[`${domain}_modified`] === 'number') {
              const totalModifierValue = hsdItem[`${domain}_modified`]
              
              // Assign full sleep modifier to first workout only
              if (dateWorkouts.length > 0) {
                // Sort workouts by start_time to find the first workout of the day
                const sortedWorkouts = dateWorkouts.sort((a, b) => {
                  const timeA = Number(a.start_time) || 0
                  const timeB = Number(b.start_time) || 0
                  return timeA - timeB
                })
                
                // Assign full modifier to the first workout
                const firstWorkout = sortedWorkouts[0]
                firstWorkout.sleep_modifier = totalModifierValue
                
                // Set sleep_modifier to 0 for all other workouts
                dateWorkouts.forEach(workout => {
                  if (workout.id !== firstWorkout.id) {
                    workout.sleep_modifier = 0
                  }
                })
              }
            } else {
              dateWorkouts.forEach(workout => {
                workout.sleep_modifier = 0
              })
            }
          })
        }
      })
    }

    const { startDate } = getThisWeekRange()
    const payload = {
      dateInfo: { from: from.clone(), to: to.clone() },
      data: requestType === 'week' ? result.week_data : result.month_data,
      progress: result.progress,
      progressText: 'Healthy Signals is a predictive system to quantify your daily lifestyle choices. Signals are generated from the modality, duration and intensity of your activities and modulated by your sleep and rejuvenation. Your score reveals how your lifestyle contributes to your physical health and function across 7 unique healthspan domains.',
      moreProgressAvg: result.more_process_avg,
      isThisWeek: moment(from.format('YYYY-MM-DD')).isSame(
        startDate.format('YYYY-MM-DD')
      ),
      weekNth: moment(from).get('week'),
      sleepData: weekData,
      overviewSummary: result,
      healthySignals: healthySignals,
      sleepPercentage,
      sleep3WeekPercentage,
      sleep3WeekAverage
    }
    return payload
  }

  async function onIndexChange(changeIndex) {
    if (showWorkoutPopup) setShowWorkoutPopup(false)
    const listIndex = activeGroups[changeIndex]
    const { dateInfo, isThisWeek } = dataList[listIndex]
    setActiveIndex(listIndex)
    if (isThisWeek || !dateInfo) return

    const { from, to } = dateInfo

    let prePayload = dataList[listIndex + 1],
      nextPayload = dataList[listIndex - 1]

    if (!prePayload || prePayload.isLoading) {
      const { startDate, endDate } = prevWeekDate(from.clone(), to.clone())
      dataList[listIndex + 1] = await fetchData(personId, startDate, endDate)
    }
    if (!nextPayload || nextPayload.isLoading) {
      const { startDate, endDate } = nextWeekDate(from.clone(), to.clone())
      dataList[listIndex - 1] = await fetchData(personId, startDate, endDate)
    }
    switch (changeIndex) {
      case 0:
        activeGroups[2] = listIndex - 1
        activeGroups[1] = listIndex + 1
        break
      case 1:
        activeGroups[0] = listIndex - 1
        activeGroups[2] = listIndex + 1
        break
      case 2:
        activeGroups[0] = listIndex + 1
        activeGroups[1] = listIndex - 1
        break
      default:
        break
    }
    dispatch({ type: 'update', payload: { dataList } })
    setActiveGroups(activeGroups)
  }

  function handleGesture(clientX, index) {
    if (pageLoading) return
    const item = dataList[index]
    if (ref.current) {
      clientX > 0
        ? dataList[index + 1] && ref.current.swipeNext()
        : !item.isThisWeek &&
          !dataList[index - 1].isLoading &&
          ref.current.swipePrev()
    }
    if (indicatorsRef.current) {
      clientX > 0
        ? dataList[index + 1] && indicatorsRef.current.swipeNext()
        : !item.isThisWeek &&
          !dataList[index - 1].isLoading &&
          indicatorsRef.current.swipePrev()
    }
  }

  function swiperTo(index) {
    if (indicatorsRef.current) {
      indicatorsRef.current.swipeTo(index)
    }
    if (ref.current) {
      index > activeIndex ? ref.current.swipeNext() : ref.current.swipePrev()
    }
  }

  function getDefaultActive() {
    if (searchParams.has('from') && searchParams.has('to')) {
      const from = searchParams.get('from')
      const { startDate } = getThisWeekRange()
      return startDate.diff(moment(from), 'week')
    } else {
      return 0
    }
  }
}
